import { Component, Inject, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef } from "@angular/core";
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import Swal from "sweetalert2";
import { IAcaoPlanoAcaoModel, IPlanoAcaoModel } from "../../../models/plano-acao-model";
import { PlanoAcaoService } from "../../../services/plano-acao.service";
import { PlanoAcaoMonitorMonitorarAcaoComponent } from "../plano-acao-monitor-monitorar-acao/plano-acao-monitor-monitorar-acao.component";
import { PlanoAcaoFormHistoricoAcaoComponent } from "../../plano-acao/plano-acao-form-preencher/plano-acao-form-historico-acao/plano-acao-form-historico-acao.component";

@Component({
  selector: 'app-plano-acao-monitor-monitorar',
  templateUrl: './plano-acao-monitor-monitorar.component.html',
  styleUrls: ['./plano-acao-monitor-monitorar.component.scss']
})
export class PlanoAcaoMonitorMonitorarComponent implements OnInit, AfterViewInit {

  public id: number = 0;
  public dataSource = new MatTableDataSource<IAcaoPlanoAcaoModel>([]);
  public visualizar: boolean = false;
  public titulo: string = "";

  public model: IPlanoAcaoModel = {} as IPlanoAcaoModel;

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    public matDialog: MatDialog,
    public servicePlanoAcao: PlanoAcaoService,
    private dialogRef: MatDialogRef<PlanoAcaoMonitorMonitorarComponent>,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.id = data?.id || 0;
    this.visualizar = data?.visualizar || false;
    this.titulo = data?.titulo || '';
  }

  ngOnInit(): void {
    this.buscar();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
  }

  public sortingDataAccessor = (item, property) => {
    switch (property) {
      case "identificador": return item?.identificador;
      case "titulo": return item?.titulo;
      case "prazo": return item?.prazo;
      case "responsavel": return item?.responsavelNome;
      case "status": return item?.status;
      default: return item[property];
    }
  };

  public buscar() {

    this.servicePlanoAcao
      .obterPorId(this.id)
      .then((res) => {

        if (res.sucesso) {

          this.model = res.dados;
          this.dataSource.data = this.model.acoes || [];

          this.cdr.detectChanges();
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
        }
      })
      .catch((err) => {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          text: err?.mensagem?.descricao || 'Erro ao carregar dados',
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      });
  }

  public modalAcao(titulo: string, visualizar: boolean, element?: IAcaoPlanoAcaoModel) {

    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-plano-monitor-acao-monitorar";
    dialogConfig.width = "70vw";
    dialogConfig.maxHeight = "180vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo,
      visualizar,
      id: element?.id,
      planoAcaoId: this.model.id,
      unidadeGestoraId: this.model.unidadeGestoraId,
      osaExecucaoId: this.model.osaExecucaoId,
      element
    };

    const modal = this.matDialog.open(PlanoAcaoMonitorMonitorarAcaoComponent, dialogConfig);

    modal.afterClosed().subscribe((data) => {
      if (data) {
        this.buscar();
      }
    });
  }

  public fechar() {
    this.dialogRef.close(!this.visualizar);
  }

  // Demanda 68742 linha 40 (crit 9): ações Concluida(8)/EmExecução(7)/AserRealizada(6)/Atendida(9)/
  // NaoAtendida(11)/AtendidaParcialmente(10)/PendenteControle(12)/NaoSeAplica(13); bloqueia FinMan/FinAut/Cancelado(6).
  podeMonitorar(acao: IAcaoPlanoAcaoModel): boolean
  {
    if (this.model?.monitoramentoFinMan === true || this.model?.monitoramentoFinAut === true) return false;
    if (this.model?.status?.codigo === 6) return false;
    const c = acao?.status?.codigo;
    return c === 6 || c === 7 || c === 8 || c === 9 || c === 10 || c === 11 || c === 12 || c === 13;
  }


  public modalHistorico(element?: IAcaoPlanoAcaoModel) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-plano-acao-acao-historico";
    dialogConfig.width = "70vw";
    dialogConfig.maxHeight = "140vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = { id: element?.id, identificador: element?.identificador, idFuncionalidade: 41 };

    const modal = this.matDialog.open(PlanoAcaoFormHistoricoAcaoComponent, dialogConfig);

    modal.afterClosed().subscribe((data) => {
      if (data) {
        this.buscar();
      }
    });
  }  

}
